<section class="overflow-hidden bg-gray3 text-primary pb-20">
  <div class="text-center text-primary weight-600 size-14 mrtb-25">
		{{ 'account.resetThePassword' | translate}}
	</div>
  <div class="login-form mrse-20">
		<div class="mrtb-10 position-relative">
			<label class="d-block size-6 weight-600 mrb-4" for="email">{{ 'account.mail' | translate}}</label>
			<input class="w-100 border-0 border-radius-10 p-4"
				[class.is-invalid]="email?.invalid && (email?.dirty ||email?.touched)"
				type="email" placeholder="test@gmail.com" [formControl]="email" name="email" id="email" />
			<div class="invalid-feedback" *ngIf="email?.invalid">
				<p *ngIf="email?.errors?.email">
				</p>
				<p *ngIf="email?.errors?.required">
				</p>
			</div>
		</div>

		<div class="mrtb-20">
			<button class="w-100 bg-primary border-0 border-radius-10 p-5 text-white size-8 weight-600" type="submit" (click)="forgetPassword()" [disabled]="isSubmitting || email.invalid">
				<span *ngIf="!isSubmitting">{{ 'account.resetThePassword' | translate}}</span>
				<img  *ngIf="isSubmitting" src="../../../../assets/images/spinner.gif" alt="" class="max-30">
			</button>
			<div class="cursor-pointer text-center mrt-5 weight-600" (click)="navigateToLogin()">{{ 'account.backToLogin' | translate}}</div>
		</div>
	</div>
  <div>
      <div class="mrt-20"><img src="../../../../assets/images/small-line.svg" alt="line" /></div>
  </div>
</section>
